import { Component } from 'react';
import styled from '@emotion/styled';

const WarrantyFooterText = styled.span`
  display: block;
  padding-top: 7px;
  margin-left: 10px;
  @media (max-width: 425px) {
    font-size: 10px;
  }
  height: 34px;
  border-top: 1px solid rgb(212, 212, 212);
  font-family: OCRoboto;
  font-size: 11px;
  color: #000;
  
  &:hover {
    color: #D40F7D;
    
    .fa {
      margin-left: 12px;
     }
  }
  
  .fa {
    display: inline-block;
    margin-left: 2px;
    transition: all ease .2s;
  }
`;

export default class WarrantyFooter extends Component {
  render() {
    return (
      <a href="https://www.owenscorning.com/roofing/warranty/?warranty=supreme#overview" data-track="learn-more">
        <WarrantyFooterText>Supreme Product Warranties <i className="fa fa-sm fa-chevron-right" /></WarrantyFooterText>
      </a>
    )
  }
}